module.exports = __webpack_public_path__ + "img/sectors.dfee7196.svg";